<template>
  <router-view/>
</template>

<script>


export default {
  name: "App",
  methods: {},

}
</script>



// WEBPACK FOOTER //
// src/App.vue